import { UserProfile } from "../types/userProfile";
import { getJSON } from "../utils/RequestUtils";

export const fetchUserProfile = async (): Promise<UserProfile> => {
  return getJSON<UserProfile>('/th/Profile/GetUserProfile');
};

